import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Shell } from "@/pages/PublicRecruit";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PublicRecruitInvite() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/public/recruit-invite/${token}`).then((r) => setD(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Convite inválido."));
  }, [token]);
  const answer = async (accept) => {
    try { const r = await axios.post(`${API}/api/public/recruit-invite/${token}`, { accept }); setD({ ...d, answer: r.data.answer }); }
    catch (e) { setError(e.response?.data?.detail || "Erro"); }
  };
  if (error) return <Shell><p className="text-[#FF6B6B]" data-testid="invite-error">{error}</p></Shell>;
  if (!d) return <Shell><p className="kw-overline">A carregar…</p></Shell>;
  return (
    <Shell>
      <div className="kw-overline mb-2">Convite · KW Lead Growth League</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black uppercase tracking-tighter">
        Coopetir pelos <span className="text-[#E50000]">{d.club}</span>?
      </h1>
      <p className="text-[#A3A3A3] mt-3 mb-8">Olá {d.name}! {d.recruiter} convidou-te para reforçar o plantel do teu clube.</p>
      {d.answer === "accepted" ? (
        <p className="text-[#22C55E] text-lg" data-testid="invite-accepted">Fantástico! O Secretário e a organização foram avisados e vão falar contigo para te pôr no plantel.</p>
      ) : d.answer === "declined" ? (
        <p className="text-[#A3A3A3]" data-testid="invite-declined">Obrigado pela resposta. Se mudares de ideias, fala com {d.recruiter}.</p>
      ) : (
        <div className="flex flex-wrap gap-3">
          <button onClick={() => answer(true)} className="kw-btn-primary" data-testid="invite-accept">Quero coopetir</button>
          <button onClick={() => answer(false)} className="kw-btn-secondary" data-testid="invite-decline">Agora não</button>
        </div>
      )}
    </Shell>
  );
}
